import { useI18N } from '@shared-core/hooks/use-i18n'
import locales from '@web/router/error-boundary/index.i18n.json'
import styles from '@web/router/error-boundary/index.module.css'
import { useMemo } from 'react'
import { useRouteError } from 'react-router-dom'

function getErrorText(error: unknown): string {
  if (error instanceof Error) return error.message

  if (typeof error === 'string') return error

  return ''
}

function isChunkLoadErrorMessage(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)

  return message.includes('Failed to fetch dynamically imported module')
}

export function RouteErrorBoundary() {
  const { t } = useI18N(locales)
  const error = useRouteError()
  // PWA-recovery (тихое самообновление после деплоя) — см. libs/pwa в исходном проекте.
  const isChunkLoadError = useMemo(() => isChunkLoadErrorMessage(error), [error])

  const handleReload = () => {
    window.location.reload()
  }

  const handleGoHome = () => {
    window.location.assign('/home')
  }

  const title = t(isChunkLoadError ? 'chunk-title' : 'generic-title')
  const description = t(isChunkLoadError ? 'chunk-description' : 'generic-description')
  const errorText = getErrorText(error)

  return (
    <div className={styles.root} role="alert">
      <div className={styles.content}>
        <div className={styles.icon}>!</div>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.button} onClick={handleReload}>
            {t('refresh')}
          </button>
          {!isChunkLoadError && (
            <button type="button" className={`${styles.button} ${styles.buttonSecondary}`} onClick={handleGoHome}>
              {t('go-home')}
            </button>
          )}
        </div>
        {__DEV__ && errorText ? <p className={styles.description}>{errorText}</p> : null}
      </div>
    </div>
  )
}
